// extracted by mini-css-extract-plugin
module.exports = {"telInput":"AppSMSInput-module__telInput___2qp4f","container":"AppSMSInput-module__container___KUpj9","textLinkButton":"AppSMSInput-module__textLinkButton___h02zo"};